import styled from '../styled-components';

interface Props {
    primary: boolean;
    normal: boolean;
}

export default styled<Props, any>('label')`
    position: relative;
    display: inline-block;
    padding: 0.46em 1.4em 0.55em;
    border: 0 none;
    border-radius: 0.1em;
    font-weight: 500;
    color: ${p => p.theme.textInverted};
    background-color: ${props => (props.normal ? props.theme.gray : props.theme.primary)};
    transition: transform 30ms ease-out;
    transform: translate3d(0, 0, 0);
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        transform: translate3d(0, -1px, 0);
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: 380px){
        width: 100%
        text-align: center;
    }
    overflow: hidden;

    [type='file'] {
        position: absolute;
        z-index: 1000;
        opacity: 0;
        cursor: pointer;
        right: 0;
        top: 0;
        height: 100%;
        font-size: 24px;
        width: 100%;
        /* font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0; */
    }
`;



// WEBPACK FOOTER //
// ./src/components/FileContainer.tsx